import {
  DropdownPrimeReact,
  DropdownPrimeReactProps,
} from "@finanedi.es/storybook"
import ModalCrearCuentaContable from "common/components/ModalCrearCuentaContable"
import { DropdownFilterParams } from "primereact/dropdown"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { dropdownCuentaContableAdapter } from "../dropdownCuentaContable.adapter"
import { DropdownOptionTemplate } from "../DropdownOptionTemplate"

export interface DropdownCuentasContables extends DropdownPrimeReactProps {
  cuentasContablesOptions?: $TSMigrationFixMe
  listaDeCuentasBase?: $TSMigrationFixMe
  inputIdName?: string
  id?: string
  dropdownValue?: string | null
  onChange: DropdownPrimeReactProps["onChange"]
  withCreateCuenta?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  refreshFetchData?: any
  nameOnCreate?: string
  cuentaPorDefecto?: $TSMigrationFixMe
  disabled?: boolean
  isNumberOrder?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors?: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  touched?: any
}
export function DropdownCuentasContablesConModal({
  cuentasContablesOptions,
  listaDeCuentasBase,
  inputIdName,
  id,
  dropdownValue,
  onChange,
  withCreateCuenta = false,
  refreshFetchData,
  nameOnCreate,
  cuentaPorDefecto,
  errors,
  touched,
  disabled,
  isNumberOrder = false,
}: DropdownCuentasContables) {
  const { t } = useTranslation()
  const [searchValue, setSearchValue] = useState("")
  const [isShowingCrearCuentaModal, setIsShowingCrearCuentaModal] =
    useState(false)
  const dropdownOptions = dropdownCuentaContableAdapter(
    cuentasContablesOptions,
    isNumberOrder
  )

  const addCuentaContableTemplate = () => {
    return (
      <div
        className='tw-w-full tw-h-10 tw-p-4'
        onClick={() => setIsShowingCrearCuentaModal(true)}
      >
        <div className='tw-cursor-pointer tw-w-full tw-h-full tw-flex tw-justify-start tw-items-center tw-pl-4 tw-hover:bg-background tw-rounded'>
          + {t("cuentasContables.addAccount")} {searchValue ?? ""}
        </div>
      </div>
    )
  }

  const onFilter = (event: DropdownFilterParams) => {
    setSearchValue(event.filter)
  }

  return (
    <>
      <DropdownPrimeReact
        {...(inputIdName && {
          id: id || inputIdName,
          name: inputIdName,
        })}
        disabled={disabled}
        className={`tw-w-full tw-rounded tw-h-10 ${
          inputIdName && errors?.[inputIdName] && touched?.[inputIdName]
            ? "!tw-border-danger"
            : "!tw-border-neutral-25"
        }`}
        panelClassName='!tw-max-w-xl !tw-z-40'
        scrollHeight='350px'
        placeholder={`${t(
          "nsAssets.modalCreate.accountingAccountCounterpartPlaceholder"
        )}`}
        emptyFilterMessage={`${t("nsAssets.modalCreate.noAccountingAccounts")}`}
        emptyMessage={`${t("nsAssets.modalCreate.noAccountingAccounts")}`}
        onChange={onChange}
        value={dropdownValue}
        valueTemplate={(option) => (
          <div>
            <span
              className={`${option ? "tw-text-text-50" : "tw-text-neutral-50"}`}
            >
              {option
                ? `${option.optionLabel}`
                : `${t("cuentasContables.placeholderAccount")}`}
            </span>
          </div>
        )}
        options={dropdownOptions}
        filterPlaceholder={`${t("cuentasContables.searchAccount")}`}
        optionValue='optionValue'
        optionLabel='optionLabel'
        itemTemplate={(option) => DropdownOptionTemplate(option?.optionLabel)}
        panelFooterTemplate={
          withCreateCuenta ? addCuentaContableTemplate : false
        }
        optionGroupLabel='groupLabel'
        optionGroupChildren='groupOptions'
        onFilter={onFilter}
        filter
      />
      {withCreateCuenta && (
        <ModalCrearCuentaContable
          visible={isShowingCrearCuentaModal}
          onHide={() => {
            setIsShowingCrearCuentaModal(false)
          }}
          initialData={searchValue}
          nameOnCreate={nameOnCreate}
          listaDeCuentasBase={listaDeCuentasBase}
          cuentaPorDefecto={cuentaPorDefecto}
          appNewCuenta={onChange}
          refreshFetchData={refreshFetchData}
        />
      )}
    </>
  )
}
